import { joinCn } from '../util';
import createTwStyle from '../util/createTwStyle';
import type { VGridProps } from './type';

const twStyle = createTwStyle<VGridProps>();

export default twStyle({
  container: () => [
    joinCn(
      'grid',
      'gap-(--gap)',
      'grid-cols-(--columns)',
      'grid-rows-(--rows)',
    ),
  ],
});
